// Structured filename for a survey photo, shared by the online result editor
// and the offline shell (card #3827). Before this, shell photos kept
// SurveyJS's raw camera name ("snap_picture.webp"), so nothing in the file
// said which response or question it belonged to -- and
// Image#find_survey_element_for_image, which matches a photo to its answer
// by filename, can't tell one snap_picture from another.
//
// Format: response_{responseId}_{question_slug}_user_{userId}_{timestamp}.{ext}
// Any id the caller doesn't have falls back to "unknown".
export function buildImageFilename({ responseId, questionName, userId, file }) {
  const slug = (questionName || "photo")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 30)
  const ts  = new Date().toISOString().replace(/[-:]/g, "").replace(/\..+/, "")
  const ext = file?.name?.split(".").pop() || "webp"
  return `response_${responseId || "unknown"}_${slug}_user_${userId || "unknown"}_${ts}.${ext}`
}

// The same file, renamed -- File objects are immutable, so this is a copy.
export function withImageFilename(file, context) {
  return new File([file], buildImageFilename({ ...context, file }), { type: file.type, lastModified: Date.now() })
}
